<template>
  <BaseNotification
    type="info"
    layout="inline"
    class="leading-5"
  >
    This space can only apply the full day rate.
    <template v-if="price">
      The hire fee will be {{ price }}, regardless of the selected duration.
    </template>
  </BaseNotification>
</template>

<script setup>

import BaseNotification from '@/components/Ui/BaseNotification.vue';

defineProps({
  price: {
    type: [Number, String],
    required: true,
  },
});
</script>
